import {computed} from 'vue';
import {useABTest, useFeatureFlag} from '@malt/feature-flags';

const ONE_ENTRY_POINT_FEATURE_FLAG = 'one-entry-point-improvements';
const ONE_ENTRY_POINT_CAMPAIGN = 'one-entry-point-improvements';

export const ONE_ENTRY_POINT_VARIANTS = {
    control: 'control',
    dispatchPage: 'dispatch-page',
    withoutDispatchPage: 'without-dispatch-page',
} as const;

/**
 * Resolves the visitor's group for the `one-entry-point-improvements` ABC test.
 *
 * Mirrors the backend `OneEntryPointExperiment`: the FF4J feature flag is a plain on/off gate, so when it
 * is off the feature is off (variant `control`) and the Amplitude variant is not read. When it is on, the
 * Amplitude variant drives the A/B/C branching.
 *
 * Exposure (`$exposure`) is owned by the front: the variant is read through `getVariation`, which tracks
 * the exposure when the feature is evaluated for display. The backend attempts to track it too, but
 * deduplicates against the event already sent here.
 */
export function useOneEntryPointExperiment() {
    const oneEntryPointImprovements = useFeatureFlag(ONE_ENTRY_POINT_FEATURE_FLAG);
    const {getVariation} = useABTest();

    const variant = computed(() => {
        if (!oneEntryPointImprovements.value) {
            return ONE_ENTRY_POINT_VARIANTS.control;
        }
        return getVariation(ONE_ENTRY_POINT_CAMPAIGN) ?? ONE_ENTRY_POINT_VARIANTS.control;
    });

    const oneEntryPointEnabled = computed(() => variant.value !== ONE_ENTRY_POINT_VARIANTS.control);

    return {variant, oneEntryPointEnabled};
}
